import React from "react";
import styles from "./WorksBody.module.css";

const WorksBody = () => {
  return (
    <div className={styles.entireWorksBody}>
      <div className={styles.worksBodyContainer}>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeaderIntro}>
            ✨ Key Features
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Fully responsive layout optimized for mobile-first breakpoints
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>Animated collapsible navigation with toggle states</span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Custom carousel implementation without external dependencies
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Serverless contact form using{" "}
                <a href="https://www.npmjs.com/package/@emailjs/browser">
                  EmailJS{" "}
                </a>
                and{" "}
                <a href="https://www.react-hook-form.com/">React Hook Form</a>
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Original JSON-driven character animations via{" "}
                <a href="https://www.npmjs.com/package/lottie-react">
                  {" "}
                  react-lottie
                </a>
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>Semantic, accessible routing with custom 404 handling</span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Design-to-code translation from Figma with accessibility best
                practices
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeaderIntro}>
            ⚙️ Implementation Details
          </h2>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Navigation & Routing
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Responsive navigation leveraging conditional rendering and
                mobile toggles
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Custom 404 routing via{" "}
                <a href="https://www.npmjs.com/package/react-router-dom">
                  react-router-dom{" "}
                </a>
                wildcard routes
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Custom Carousel UX
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              Native horizontal carousel using scrollBy() and useRef()
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              Swipe gesture logic optimized for mobile devices
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              No external libraries used—maximizing control and performance
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Contact Form Integration
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              Serverless form submission via{" "}
              <a href="https://www.npmjs.com/package/react-hook-form">
                react-hook-form{" "}
              </a>
              and <a href="https://www.emailjs.com/"> EmailJS</a>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              Animated validation and error handling for enhanced UX
            </p>
          </div>
        </div>

        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            🧰 Frontend Engineering & Dev Tools
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <div className={styles.worksBodyKeyPointsDetailAndAnchorContainer}>
              <p className={styles.worksBodyKeyPointsDetail}>
                Conditional rendering via{" "}
                <a href="https://www.npmjs.com/package/react-responsive">
                  react-responsive{" "}
                </a>
                for adaptive layouts
              </p>
            </div>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <div className={styles.worksBodyKeyPointsDetailAndAnchorContainer}>
              <p className={styles.worksBodyKeyPointsDetail}>
                Original animations created using{" "}
                <a href="https://www.npmjs.com/package/lottie-react">
                  {" "}
                  react-lottie{" "}
                </a>
                tied to personal branding
              </p>
            </div>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <div className={styles.worksBodyKeyPointsDetailAndAnchorContainer}>
              <p className={styles.worksBodyKeyPointsDetail}>
                Docker-based isolated environments for streamlined builds
              </p>
            </div>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <div className={styles.worksBodyKeyPointsDetailAndAnchorContainer}>
              <p className={styles.worksBodyKeyPointsDetail}>
                Real-time deployment previews with Vercel for rapid iteration
                and collaboration
              </p>
            </div>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            🎨 Design Collaboration & Accessibility
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <div className={styles.worksBodyKeyPointsDetailAndAnchorContainer}>
              <p className={styles.worksBodyKeyPointsDetail}>
                Co-designed the layout with my partner in Figma
              </p>
            </div>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <div className={styles.worksBodyKeyPointsDetailAndAnchorContainer}>
              <p className={styles.worksBodyKeyPointsDetail}>
                Applied visual feedback from real device testing across screen
                sizes
              </p>
            </div>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <div className={styles.worksBodyKeyPointsDetailAndAnchorContainer}>
              <p className={styles.worksBodyKeyPointsDetail}>
                Used semantic HTML tags with ARIA attributes and alt text for
                accessibility compliance
              </p>
            </div>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            📈 Why This Matters
          </h2>
          <p className={styles.worksBodyKeyPointsDetail}>
            This was my first fully self-directed project—and it remains the
            foundation of my online presence. I didn’t just deploy a site; I
            planned, engineered, and refined every piece of it.
          </p>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                First fully self-directed project, now core to my professional
                presence
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Independently built and deployed a branded, responsive site
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Gained practical experience with responsive design, form
                interactions, and UI architecture
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Demonstrated effective collaboration and translation of design
                into working code
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Evolved through iterative improvements based on real-world use
                and feedback
              </span>
            </p>
          </div>
          <p className={styles.worksBodyKeyPointsDetail}>
            This site continues to evolve as I grow — I built it to be
            maintainable, modular, and easy to update as I gain new experience,
            complete projects, and refine my presentation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WorksBody;
